export const colors = {
  bg: "#fafafa",
  card: "#ffffff",
  border: "#e0e0e0",
  text: "#333",
  muted: "#777",
  accent: "#1d4ed8",
  shadow: "0 2px 10px rgba(0,0,0,0.10)",
};

